export const featuredProducts = [
  {
    id: 'fp1',
    name: '中國女童春季碎花連衣裙',
    price: 60,
    image: 'https://public.readdy.ai/ai/img_res/ea0498c1572b5ffbcd9bc66b84cdf9e8.jpg',
    category: '女童'
  },
  {
    id: 'fp2',
    name: '男童休閒運動套裝',
    price: 50,
    image: 'https://readdy.ai/api/search-image?query=Stylish%20Korean%20boys%20casual%20sportswear%20set%20with%20navy%20blue%20hoodie%20and%20matching%20jogger%20pants%20on%20pure%20white%20background%20product%20photography%20style%20with%20clean%20minimal%20aesthetic&width=400&height=500&seq=fp2&orientation=portrait',
    category: '男童'
  },
  {
    id: 'fp3',
    name: '嬰兒純棉連身衣套裝',
    price: 60,
    image: 'https://readdy.ai/api/search-image?query=Adorable%20baby%20romper%20set%20in%20soft%20pastel%20colors%20made%20of%20organic%20cotton%20with%20cute%20animal%20prints%20on%20pure%20white%20background%20product%20photography%20style%20with%20gentle%20lighting&width=400&height=500&seq=fp3&orientation=portrait',
    category: 'BABY'
  },
  {
    id: 'fp4',
    name: '女童針織開衫外套',
    price: 60,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20girls%20knit%20cardigan%20sweater%20in%20cream%20white%20color%20with%20delicate%20button%20details%20and%20soft%20texture%20on%20pure%20white%20background%20product%20photography%20style&width=400&height=500&seq=fp4&orientation=portrait',
    category: '女童'
  },
  {
    id: 'fp5',
    name: '男童牛仔外套',
    price: 60,
    image: 'https://readdy.ai/api/search-image?query=Trendy%20Korean%20boys%20denim%20jacket%20in%20classic%20blue%20wash%20with%20modern%20fit%20and%20stylish%20details%20on%20pure%20white%20background%20product%20photography%20style%20with%20professional%20lighting&width=400&height=500&seq=fp5&orientation=portrait',
    category: '男童'
  },
  {
    id: 'fp6',
    name: '女童格子百褶裙',
    price: 50,
    image: 'https://readdy.ai/api/search-image?query=Cute%20Korean%20girls%20plaid%20pleated%20skirt%20in%20navy%20and%20white%20check%20pattern%20with%20elastic%20waistband%20on%20pure%20white%20background%20product%20photography%20style%20with%20clean%20aesthetic&width=400&height=500&seq=fp6&orientation=portrait',
    category: '女童'
  },
  {
    id: 'fp7',
    name: '男童條紋T恤',
    price: 50,
    image: 'https://readdy.ai/api/search-image?query=Classic%20Korean%20boys%20striped%20t-shirt%20in%20navy%20and%20white%20horizontal%20stripes%20with%20comfortable%20cotton%20fabric%20on%20pure%20white%20background%20product%20photography%20style&width=400&height=500&seq=fp7&orientation=portrait',
    category: '男童'
  },
  {
    id: 'fp8',
    name: '嬰兒針織毛衣',
    price: 60,
    image: 'https://readdy.ai/api/search-image?query=Soft%20baby%20knit%20sweater%20in%20gentle%20beige%20color%20with%20cute%20teddy%20bear%20pattern%20made%20of%20premium%20yarn%20on%20pure%20white%20background%20product%20photography%20style%20with%20warm%20lighting&width=400&height=500&seq=fp8&orientation=portrait',
    category: 'BABY'
  }
];